import { Component, Input, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { Reactions, Threads, TimelineItem, TimelineItemType } from "@teammood/timeline";
import { MatTabsModule } from '@angular/material/tabs';
import { ReactionsComponent } from "../../reaction";
import { ThreadsComponent } from "../../../threads/threads.component";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
import { PollResultService } from "../poll-result.service";
import { UserInfos } from "../../../../shared/ui/username-icon/user-infos.type";
import { ReviewBadgeComponent } from "../../review-badge/review-badge.component";
import { PollResultCommentsComponent } from "../poll-result-comments/poll-result-comments.component";
import { FiveStarsPollResultTimelineItem, PollResultValue } from "../poll-result.type";
import { RecurringPollResultTrendsComponent } from "../recurring/recurring-poll-result-trends.component";
import { ManagerPanelComponent } from "../../manager-panel/manager-panel.component";

@Component({
    selector: "tm-five-stars-poll-result-card",
    templateUrl: "./five-stars-poll-result.component.html",
    styleUrls: ['./five-stars-poll-result.component.scss', './../poll-result.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        MatTabsModule,
        ReactionsComponent,
        ThreadsComponent,
        TranslateModule,
        ReviewBadgeComponent,
        PollResultCommentsComponent,
        RecurringPollResultTrendsComponent,
        ManagerPanelComponent
    ]
})
export class FiveStarsPollResultCardComponent implements OnInit {
    
    protected showTimelineItemOptions: boolean;
    protected tabIndexToShow: number = 0;
    protected showThreads: boolean = true;
    protected resultsTabLabel: string;
    protected trendsTabLabel: string;
    protected average: {
        averageScore: string; // toFixed methode return sting from number
        people: number
    }
    dontWantToAnswerItem: PollResultValue;
    participationCount: number;

    @ViewChild('threadsComponent')
    private threadsComponent: ThreadsComponent;

    @Input() 
    pollResult: FiveStarsPollResultTimelineItem

    @Input() teamId: string;
    
    @Input() userInfos: UserInfos;

    @Input() isOdd: boolean;
    
    constructor(
        private translateService: TranslateService,
        private pollResultService: PollResultService
    ) {
        this.resultsTabLabel = this.translateService.instant('poll_results.results')
        this.trendsTabLabel = this.translateService.instant('poll_results.trends')
    }

    ngOnInit(): void {
        this.average = this.pollResultService.formatFiveStarsPollResult(this.pollResult.results.values)
        this.dontWantToAnswerItem = this.pollResult.results.values.find(x => x.choice === "don-t-want-to-answer")
        this.participationCount = this.pollResultService.getParticipationCount(this.pollResult.results.values)
    }

    onTabChanged(event){
        this.tabIndexToShow = event.index;
    }

    protected toggleThreads() {
        this.showThreads = !this.showThreads;
    }
    protected discuss() {
        if (this.threadsComponent) {
            this.threadsComponent.discuss = true;
        }
    }

    protected onReacted(timelineItem: {id: string, itemType: TimelineItemType} & Reactions): void {
        if (timelineItem.itemType == "fiveStarsQuestionResultItem"){
            this.pollResult = timelineItem as FiveStarsPollResultTimelineItem;
        }
    }

    protected onThreadsUpdated(timelineItem: TimelineItem & Threads): void {
        if (timelineItem.itemType == "fiveStarsQuestionResultItem"){
            this.pollResult = timelineItem as FiveStarsPollResultTimelineItem;
        }
    }
}